import { CustomFilterConfig, CustomFilterSectionType } from './types';

export const DEFAULT_FILTER_KEY_TO_CUSTOM_FILTER_CONFIG: Record<string, CustomFilterConfig> = {
	destination: {
		container: 'filter_destination',
		labelDictionaryKey: 'labelUniqueDestination',
		sections: [
			{
				section: CustomFilterSectionType.Default,
				labelDictionaryKey: 'labelUniqueDestination',
			},
			{
				section: CustomFilterSectionType.River,
				labelDictionaryKey: 'labelUniqueRiverDestination',
			},
		],
	},
	startDate: {
		container: 'filter_start_date',
		labelDictionaryKey: 'labelSpecialDates',
	},
	ship: {
		container: 'filter_ship',
		labelDictionaryKey: 'labelSpecialShips',
	},
};

export const CRUISE_DATES_FILTER = {
	key: 'startDate',
	label: 'Cruise Dates',
	dictionaryLabel: 'navCruiseDates',
	dictionarySubLabel: '',
};
export const DESTINATION_FILTER = {
	key: 'destination',
	label: 'Destinations',
	dictionaryLabel: 'navDestination',
	dictionarySubLabel: 'labelAllDestinations',
};
export const DESTINATION_PORT = 'port';
export const DESTINATION_REGION = 'region';
export const DEPARTURE_PORT_FILTER = {
	key: 'departurePort',
	label: 'Departure Ports',
	dictionaryLabel: 'navDeparturePort',
	dictionarySubLabel: '',
};
export const NIGHTS_FILTER = {
	key: 'nights',
	label: 'Number of Nights',
	dictionaryLabel: 'navNights',
	dictionarySubLabel: 'labelLengthOfCruise',
};
export const SHIP_FILTER = {
	key: 'ship',
	label: 'Ships',
	dictionaryLabel: 'navShips',
	dictionarySubLabel: 'labelAllOurShips',
};

export const VOYAGE_TYPE_FILTER = {
	key: 'voyageType',
	label: 'Cruise Type',
	dictionaryLabel: 'navCruiseType',
	dictionarySubLabel: 'subtitleCruiseType',
};

export const NUMBER_OF_GUESTS_FILTER_KEY = 'numberOfGuests';
export const PROMO_KEY = 'promo';

export const MISSING_PORT_CONTENT = 'MISSING PORT CONTENT';

export const NUMBER_OF_GUESTS_LOCAL_STORAGE = {
	key: 'NumberOfGuests',
	adults: 'adults',
	children: 'children',
};

export const HEADER_MARGIN = {
	desktop: -300,
	mobile: -400,
};

export const APPLIED_FILTERS_WIDTH = {
	baseMargin: 10,
	defaultMaxWidth: '1280px',
};

export const EVENT_CLEAN_WIDGET_FILTERS = 'onCleanWidgetFilters';

export const NIGHTS_LABEL_APPENDER = '{{nights}}';

export const EXTERNAL_FILTERS = [PROMO_KEY];

export const DEFAULT_PROMO_TITLE = 'Promo';

export const PROMOTION_STATUS_ACTIVE = 'active';
